import script from "./CadastroQuarto.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroQuarto.vue?vue&type=script&setup=true&lang=js"

import "./CadastroQuarto.vue?vue&type=style&index=0&id=2caecf6d&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2caecf6d"]])

export default __exports__